import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasAlora() {
  return (
    <CityPagePersianas
      name="Álora"
      slug="alora"
      cp="29500"
      poblacion={13000}
      zonaGeo="Guadalhorce"
      lat={36.8237}
      lng={-4.7058}
      zonas={[
        "Centro Álora",
        "La Estación",
      ]}
      landmarks={[
        "Castillo de Álora",
        "Caminito del Rey",
        "Iglesia Encarnación",
      ]}
      municipiosLimitrofes={[
        "Pizarra",
        "Cártama",
        "Carratraca",
        "Antequera",
      ]}
      festivalLocal="Feria de Álora, primera semana de agosto"
      contextoTipologico="Pueblo blanco icónico con casco antiguo histórico, turismo del Caminito del Rey, hostelería con toldos."
      isCoreZone={false}
    />
  );
}